module.exports = __webpack_public_path__ + "static/media/xcRMRK.1b4a7036.png";